import React from "react";

const AboutInstituteSection = () => {
  return (
    <section className="w-full bg-white py-20 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* Text Content */}
        <div>
          <span className="inline-block mb-4 px-4 py-1 text-sm font-semibold text-white bg-[#112E65] rounded-full">
            About Our Institute
          </span>
          <h2 className="text-4xl font-bold text-[#112E65] mb-6 leading-tight">
            Empowering Rural Students with World‑Class Pharmaceutical Education
          </h2>
          <p className="text-gray-600 leading-relaxed mb-4">
            Sumatidevi Tompe Institute of Pharmaceutical Science and Research,
            located in Chandur Bazar, Amravati, is a premier institution dedicated
            to bridging rural talent with urban academic standards in pharmacy
            education.
          </p>
          <p className="text-gray-600 leading-relaxed">
            Our campus offers advanced laboratories, smart classrooms, a
            resource-rich library, digital learning support, and a 10,000 sq. ft.
            state-of-the-art auditorium — all guided by highly qualified faculty
            committed to student success.
          </p>
        </div>

        {/* Highlight Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <div className="p-6 rounded-xl shadow-md border border-gray-100 hover:shadow-xl transition">
            <h4 className="text-lg font-semibold text-[#112E65] mb-2">
              Modern Infrastructure
            </h4>
            <p className="text-sm text-gray-600">
              Advanced labs, smart classrooms, high-speed Wi‑Fi, and digital
              research facilities.
            </p>
          </div>

          <div className="p-6 rounded-xl shadow-md border border-gray-100 hover:shadow-xl transition">
            <h4 className="text-lg font-semibold text-[#112E65] mb-2">
              Expert Faculty
            </h4>
            <p className="text-sm text-gray-600">
              Highly qualified educators dedicated to academic excellence and
              student mentoring.
            </p>
          </div>

          <div className="p-6 rounded-xl shadow-md border border-gray-100 hover:shadow-xl transition">
            <h4 className="text-lg font-semibold text-[#112E65] mb-2">
              Practical Learning
            </h4>
            <p className="text-sm text-gray-600">
              Hands-on training with modern instruments and industry-oriented
              practices.
            </p>
          </div>

          <div className="p-6 rounded-xl shadow-md border border-gray-100 hover:shadow-xl transition">
            <h4 className="text-lg font-semibold text-[#112E65] mb-2">
              Grand Auditorium
            </h4>
            <p className="text-sm text-gray-600">
              10,000 sq. ft. auditorium with premium AV systems for academic and
              cultural events.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutInstituteSection;

